import { Component, h, Host, Element } from '@stencil/core';

/**
 * @slot icon - {required}, <me-icon>
 * @slot heading - {required}, <me-heading variant="5">
 * @slot description - {required}, <me-text>
 */

@Component({
  tag: 'features-card-type-6',
  styleUrl: 'index.scss',
  shadow: false,
})
export class FeaturesCardType6 {
  @Element() host: HTMLElement;

  render() {
    // Get position from host attributes if present (for microdata)
    const positionAttr = this.host.getAttribute('position');
    const hasItemscope = this.host.hasAttribute('itemscope');
    const itemtypeAttr = this.host.getAttribute('itemtype');
    const itempropAttr = this.host.getAttribute('itemprop');

    return (
      <Host class="features-card-type-6" itemScope={hasItemscope || undefined} itemType={itemtypeAttr || undefined} itemProp={itempropAttr || undefined}>
        <div class="features-card-type-6__icon">
          <slot name="icon"></slot>
        </div>
        <slot name="heading"></slot>
        <slot name="description"></slot>
        {hasItemscope && positionAttr && <meta itemProp="position" content={positionAttr} />}
      </Host>
    );
  }
}
